import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

/** Condición de tarifa del proveedor (mismo shape en trenes y autos). */
export interface FareCondition {
  type: string;
  description: string;
  /** Tope asociado a la condición (ej. "Unlimited Miles" en kilometraje). */
  limit?: string;
}

interface Props {
  conditions: FareCondition[];
  /** Clave de i18n con las etiquetas por tipo; el tipo crudo es el fallback. */
  typeLabelPrefix: string;
}

/**
 * La letra chica de la tarifa tal como la publica el proveedor: cambios y
 * devolución en trenes, coberturas y kilometraje en autos. Solo se traduce la
 * ETIQUETA del tipo — el texto es del operador y se transmite literal.
 */
export function FareConditionsList({ conditions, typeLabelPrefix }: Props) {
  const { t } = useTranslation();

  return (
    <Box bgcolor="grey.100" borderRadius={1} px={1.5} py={1}>
      {conditions.map((condition, index) => (
        <Box key={index} mb={0.5}>
          <Typography variant="caption" fontWeight={600}>
            {t(`${typeLabelPrefix}.${condition.type}`, {
              defaultValue: condition.type,
            })}
            {condition.limit ? `: ${condition.limit}` : ''}
          </Typography>
          {condition.description && (
            <Typography variant="caption" display="block" color="text.secondary">
              {condition.description}
            </Typography>
          )}
        </Box>
      ))}
    </Box>
  );
}
